import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import de from 'vuetify/es5/locale/de'

Vue.use(Vuetify)

export const conf = {
  lang: {
    locales: { de },
    current: 'de',
  },
  icons: {
    iconfont: 'mdi'
  }
}

export default new Vuetify(conf)
